export interface UIState {
  isLoading: boolean
  isRefreshingStats: boolean
}

export type UIDispatch = (arg0: UIAction) => void

export type UIAction =
  | { type: 'LOADING' }
  | { type: 'NOT_LOADING' }
  | { type: 'REFRESHING_STATS' }
  | { type: 'NOT_REFRESHING_STATS' }

export function initialUiState(): UIState {
  return {
    isLoading: true,
    isRefreshingStats: false,
  }
}

export default function reducer(state: UIState, action: UIAction): UIState {
  switch (action.type) {
    case 'NOT_LOADING':
      return { ...state, isLoading: false }

    case 'LOADING':
      return { ...state, isLoading: true }

    case 'REFRESHING_STATS':
      return { ...state, isRefreshingStats: true }

    case 'NOT_REFRESHING_STATS':
      return { ...state, isRefreshingStats: false }

    default:
      return state
  }
}
